/* MJM cart page: in-place quantity updates, removals, quick add, notes and the sticky checkout bar. */
(function () {
  if (window.__mjmCart) return;
  window.__mjmCart = true;

  var root = function () { return document.querySelector('[data-mjmc]'); };
  var sectionId = function () { var r = root(); return r ? r.getAttribute('data-section-id') : null; };
  var timers = {};
  var busy = false;

  function announce(msg) {
    var l = document.querySelector('[data-mjmc-live]');
    if (l) { l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 30); }
  }

  function syncHeader(count) {
    document.querySelectorAll('[data-bind="itemCount"]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-ajax-cart-trigger]').forEach(function (el) { el.classList.toggle('has-cart-count', count > 0); });
    try { if (window.PXUTheme && PXUTheme.jsAjaxCart && PXUTheme.jsAjaxCart.updateView) PXUTheme.jsAjaxCart.updateView(); } catch (e) {}
    document.dispatchEvent(new CustomEvent('mjm:cart-updated', { detail: { item_count: count } }));
  }

  function swap(html) {
    var old = root();
    if (!old || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-mjmc]');
    if (!fresh) return;
    // Keep the already-initialised Shop Pay / PayPal / Google Pay buttons.
    var oldExpress = old.querySelector('.mjmc-express-btns');
    var newExpress = fresh.querySelector('.mjmc-express-btns');
    var focusSel = null;
    var a = document.activeElement;
    if (a && old.contains(a)) {
      var line = a.closest('[data-mjmc-line]');
      if (line && a.hasAttribute('data-mjmc-step')) focusSel = '[data-key="' + line.getAttribute('data-key') + '"] [data-mjmc-step="' + a.getAttribute('data-mjmc-step') + '"]';
      else if (line && a.hasAttribute('data-mjmc-input')) focusSel = '[data-key="' + line.getAttribute('data-key') + '"] [data-mjmc-input]';
    }
    var noteOpen = old.querySelector('.mjmc-note[open]');
    old.replaceWith(fresh);
    if (oldExpress && newExpress) newExpress.replaceWith(oldExpress);
    if (noteOpen) { var n = fresh.querySelector('.mjmc-note'); if (n) n.open = true; }
    if (focusSel) { var f = fresh.querySelector(focusSel); if (f && !f.disabled) f.focus(); }
    initSticky();
  }

  function refresh() {
    var id = sectionId();
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { swap(html); });
  }

  function change(line, qty) {
    var key = line.getAttribute('data-key');
    line.classList.add('is-busy');
    var err = line.querySelector('[data-mjmc-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    var id = sectionId();
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: [id], sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (!res.ok) {
        line.classList.remove('is-busy');
        var input = line.querySelector('[data-mjmc-input]');
        if (input) input.value = line.getAttribute('data-qty');
        if (err) { err.textContent = res.j.description || res.j.message || 'Sorry, that quantity is not available.'; err.hidden = false; }
        return;
      }
      if (res.j.sections && res.j.sections[id]) swap(res.j.sections[id]); else refresh();
      syncHeader(res.j.item_count);
      announce(qty === 0 ? 'Item removed. Cart updated.' : 'Quantity updated.');
    }).catch(function () { line.classList.remove('is-busy'); refresh(); });
  }

  function normalise(line, val) {
    var step = parseInt(line.getAttribute('data-step'), 10) || 1;
    var min = parseInt(line.getAttribute('data-min'), 10) || 1;
    var max = line.hasAttribute('data-max') ? parseInt(line.getAttribute('data-max'), 10) : null;
    val = parseInt(val, 10);
    if (isNaN(val) || val <= 0) return 0;
    if (val < min) val = min;
    if (step > 1 && val % step !== 0) val = Math.ceil(val / step) * step;
    if (max !== null && !isNaN(max) && val > max) val = step > 1 ? Math.floor(max / step) * step : max;
    return val;
  }

  function schedule(line, qty) {
    var key = line.getAttribute('data-key');
    var input = line.querySelector('[data-mjmc-input]');
    if (input) input.value = qty;
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      if (String(qty) === line.getAttribute('data-qty')) return;
      change(line, qty);
    }, qty === 0 ? 0 : 350);
  }

  document.addEventListener('click', function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;

    var stepBtn = e.target.closest('[data-mjmc-step]');
    if (stepBtn) {
      e.preventDefault();
      var line = stepBtn.closest('[data-mjmc-line]');
      var input = line.querySelector('[data-mjmc-input]');
      var step = parseInt(line.getAttribute('data-step'), 10) || 1;
      var min = parseInt(line.getAttribute('data-min'), 10) || 1;
      var cur = parseInt(input.value, 10) || 0;
      var dir = parseInt(stepBtn.getAttribute('data-mjmc-step'), 10);
      var next = cur + dir * step;
      if (dir < 0 && next < min) next = 0;
      next = normalise(line, next);
      schedule(line, next);
      return;
    }

    var rm = e.target.closest('[data-mjmc-remove]');
    if (rm) { e.preventDefault(); change(rm.closest('[data-mjmc-line]'), 0); return; }

    var clr = e.target.closest('[data-mjmc-clear]');
    if (clr) {
      e.preventDefault();
      if (!window.confirm(clr.getAttribute('data-confirm') || 'Remove everything from your cart?')) return;
      r.querySelectorAll('[data-mjmc-line]').forEach(function (l) { l.classList.add('is-busy'); });
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () { syncHeader(0); return refresh(); })
        .then(function () { announce('Cart emptied.'); });
      return;
    }

    var add = e.target.closest('[data-mjmc-add]');
    if (add) {
      e.preventDefault();
      if (add.classList.contains('is-busy')) return;
      add.classList.add('is-busy');
      var id = sectionId();
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-mjmc-add'), 10), quantity: 1 }], sections: [id], sections_url: window.location.pathname })
      }).then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
        .then(function (res) {
          add.classList.remove('is-busy');
          if (!res.ok) { add.textContent = 'Sold out'; add.disabled = true; return; }
          if (res.j.sections && res.j.sections[id]) swap(res.j.sections[id]); else refresh();
          fetch('/cart.js', { credentials: 'same-origin' }).then(function (c) { return c.json(); }).then(function (c) { syncHeader(c.item_count); });
          announce('Added to cart.');
        }).catch(function () { add.classList.remove('is-busy'); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-mjmc-input]');
    if (!input) return;
    var line = input.closest('[data-mjmc-line]');
    schedule(line, normalise(line, input.value));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('[data-mjmc-input]')) {
      e.preventDefault();
      e.target.blur();
    }
  });

  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest && e.target.closest('[data-mjmc-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }, 500);
  });

  // Save the note before leaving for checkout, and stop double submits.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'cart_form') return;
    var btn = e.submitter;
    if (btn && btn.disabled) { e.preventDefault(); return; }
    var r = root();
    if (r) r.querySelectorAll('[name="checkout"]').forEach(function (b) { b.classList.add('is-busy'); });
  });

  // Sticky checkout bar on phones: shows once both checkout buttons are off screen.
  var io;
  function initSticky() {
    if (io) io.disconnect();
    var r = root(); if (!r || !('IntersectionObserver' in window)) return;
    var bar = r.querySelector('[data-mjmc-sticky]');
    var targets = [r.querySelector('[data-mjmc-topbar]'), r.querySelector('[data-mjmc-checkout]')].filter(Boolean);
    if (!bar || !targets.length) return;
    var visible = new Map();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible.set(en.target, en.isIntersecting); });
      var anyVisible = false;
      visible.forEach(function (v) { if (v) anyVisible = true; });
      bar.classList.toggle('is-on', !anyVisible);
      bar.setAttribute('aria-hidden', anyVisible ? 'true' : 'false');
      var b = bar.querySelector('button'); if (b) b.tabIndex = anyVisible ? -1 : 0;
    }, { threshold: 0 });
    targets.forEach(function (t) { visible.set(t, true); io.observe(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
})();
